export enum MentionMetadataTypesEnum {
    mediaType = 'mediaType',
    outlet = 'outlet',
    outletIcon = 'outletIcon',
    author = 'author',
    audienceReach = 'audienceReach',
    sentiment = 'sentiment',
    location = 'location',
    wordCount = 'wordCount',
    duration = 'duration',
    domainAuthority = 'domainAuthority',
    keywords = 'keywords',
    image = 'image',
    ave = 'ave',
    publishedDate = 'publishedDate',
    engagement = 'engagement'
}
